import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { useSearchPanelView } from "../SearchPanel.context";

export function useSearchPanelFooter<T>() {
  const {
    itemsPerPage,
    itemsPerPageOptions,
    onItemsPerPageChange,
    onPageChange,
    page,
    totalCount,
  } = useSearchPanelView<T>();

  const { mdUp } = useBreakpoints();

  return {
    itemsPerPage,
    itemsPerPageOptions,
    onItemsPerPageChange,
    onPageChange,
    page,
    totalCount,
    mdUp,
  };
}
